interface GraphLegendProps {
  colourMap: Map<string, string>   // intent_name → hex colour
}

export function GraphLegend({ colourMap }: GraphLegendProps) {
  if (colourMap.size === 0) return null

  return (
    <div className="absolute top-2 left-2 z-10 bg-white bg-opacity-90 border border-gray-200 rounded-lg shadow-sm p-2.5">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Intent</p>
      <div className="space-y-1">
        {Array.from(colourMap.entries()).map(([intentName, colour]) => (
          <div key={intentName} className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: colour }} />
            <span className="text-xs text-gray-700">{intentName}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
